import { apiRequest } from '../../lib/api';
import {
  guestAccessSchema,
  mentionMutationResultSchema,
  okResultSchema,
  salesResetResultSchema,
  salesMentionsPayloadSchema,
  statsFreshResultSchema,
  statsPayloadSchema,
  statsRoomMutationSchema,
  statsRoomsResultSchema,
  statsSalesPayloadSchema,
} from '../../lib/schemas';
import type { SalesMentionsPayload, StatsPayload, StatsSalesPayload } from '../../types';

function localDayStart(): number {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

export function getStats(signal?: AbortSignal): Promise<StatsPayload> {
  return apiRequest(`/api/stats?dayStart=${localDayStart()}`, statsPayloadSchema, signal ? { signal } : {});
}

export function getStatsSales(signal?: AbortSignal): Promise<StatsSalesPayload> {
  return apiRequest('/api/stats/sales', statsSalesPayloadSchema, signal ? { signal } : {});
}

export function getSalesMentions(signal?: AbortSignal): Promise<SalesMentionsPayload> {
  return apiRequest('/api/sales/mentions', salesMentionsPayloadSchema, signal ? { signal } : {});
}

export function clearSalesMentions(): Promise<{ ok?: boolean | undefined; mentions?: unknown[] | undefined }> {
  return apiRequest('/api/sales/mentions/clear', mentionMutationResultSchema, { method: 'POST' });
}

export function resyncStats(): Promise<{ rooms: Array<{ room: string; ok?: boolean | undefined; count?: number | null | undefined; reason?: string | undefined }> }> {
  return apiRequest('/api/stats/resync', statsRoomsResultSchema, { method: 'POST' });
}

export function setRoomStatsStart(roomId: number, statsStart: number | null): Promise<{ ok: true; stats_start: number | null }> {
  return apiRequest(`/api/stats/room/${roomId}/start`, statsRoomMutationSchema, {
    method: 'POST',
    body: JSON.stringify({ stats_start: statsStart }),
  });
}

export function resetStatsBaseline(): Promise<{ ok: true }> {
  return apiRequest('/api/stats/reset-baseline', okResultSchema, { method: 'POST' });
}

export function startStatsFresh(): Promise<{ ok: true; rooms: Array<{ room: string; count?: number | null | undefined; reason?: string | undefined }> }> {
  return apiRequest('/api/stats/start-fresh', statsFreshResultSchema, { method: 'POST' });
}

export function resetSalesSince(since?: number): Promise<{ ok: true; sinceAt: number }> {
  return apiRequest('/api/stats/sales/reset', salesResetResultSchema, {
    method: 'POST',
    body: JSON.stringify(since === undefined ? {} : { since }),
  });
}

export function getGuestAccess(): Promise<{ token: string; passcodeSet: boolean }> {
  return apiRequest('/api/guest-access', guestAccessSchema);
}
